// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"aa9bf20b","453":"c1320ecf","625":"83dd07b2"}[chunkId] + ".chunk.js";
};